import { Autocomplete, FormControl, FormLabel, TextField } from '@mui/material';

import { useDAL } from '@/contexts/useDAL';

import { EmptySelect } from './emptySelect';

export const NetworkInterfaceSelect = ({
  accountId,
  resourceGroup,
  networkInterface,
  location,
  onChange,
}: {
  accountId?: string;
  resourceGroup?: string;
  networkInterface?: string;
  location?: string;
  onChange: (networkInterface: string) => void;
}) => {
  if (!accountId || !resourceGroup || !location) {
    return <EmptySelect title='Network Interface' />;
  }

  return (
    <InnerNetworkInterfaceSelect
      accountId={accountId}
      resourceGroup={resourceGroup}
      networkInterface={networkInterface}
      location={location}
      onChange={onChange}
    />
  );
};

const InnerNetworkInterfaceSelect = ({
  accountId,
  resourceGroup,
  networkInterface,
  location,
  onChange,
}: {
  accountId: string;
  resourceGroup: string;
  networkInterface?: string;
  location: string;
  onChange: (networkInterface: string) => void;
}) => {
  const dal = useDAL();
  const { data: body } =
    dal.restore.azureRestoreConfig.useListNetworkInterfaces(
      accountId,
      resourceGroup
    );
  const regionNics = body?.networkInterfaces
    .filter((ni) => ni.location === location)
    .map((ni) => ni.name);
  if (!regionNics?.length) {
    return <EmptySelect title='Network Interface' />;
  }

  return (
    <FormControl size='small' className='flex-1'>
      <FormLabel>Network Interface</FormLabel>
      <Autocomplete
        clearOnBlur
        size='small'
        value={networkInterface || null}
        onChange={(event, newValue) => onChange(newValue || '')}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              placeholder='Select'
              label=''
              InputLabelProps={{ shrink: true }}
            />
          );
        }}
        options={regionNics}
      />
    </FormControl>
  );
};
